import { useQuery } from '@tanstack/react-query'
import { ClientBookingReservationService } from '../services/client_booking_reservation.service'
import { BookingReservationClientDto, CreateBookingOrderInput } from '../types'
import { defaultQueryOptions } from './common'

export const useClientBookingReservation = (locationName: string, bookingOrder?: CreateBookingOrderInput) => {
  return useQuery<BookingReservationClientDto | null>({
    queryKey: ['clientBookingReservation', locationName],
    queryFn: () => ClientBookingReservationService.makeReservation(locationName, bookingOrder!),
    enabled: Boolean(bookingOrder),
    ...defaultQueryOptions,
  })
}
